import { render, staticRenderFns } from "./SalesPersonForm.vue?vue&type=template&id=b34d7a2c"
import script from "./SalesPersonForm.vue?vue&type=script&lang=js"
export * from "./SalesPersonForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports